/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */

/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneSafari
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7 = function() {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped.call(this);
};
/* __super__ is defined below, and used above :)
 * This is OK because below is operated at load time (as is the definition of the constructor).
 * Above is operated at construction time.
 */
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplOverlapped,		// The extend defines the __super__
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7"
                 );


 /* The Keyboard table is an array of items that are defined following the table
  * The table's key is the height of the screen
  *   From the height we can look up the:
  *     1) keyboard overhead with predictive text
  *     2) keyboard overhead without predictive text
  *     3) Fudge factor overhead for landscape
  *     4) Fudge factor overhead for chromed
  *     */

//region KeyboardTable definition for different iPhone models

/** KeyboardTable constants arrays.
 */

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues = {};
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_PORTRAIT = [253, 217, 0, 0];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_LANDSCAPE = [193,193, 40, 44];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE5_PORTRAIT = [252, 216, 0, 0];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE5_LANDSCAPE = [193, 163, 0, 44];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT = [258, 216, 48, 0];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE = [239, 209, 0, 44];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_PORTRAIT = [271, 229, 48, 0];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_LANDSCAPE = [238, 208, 0, 44];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEX_PORTRAIT = [295, 253, 38, 0];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEX_LANDSCAPE = [193, 193, 40, 44];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_PORTRAIT = [305, 263, 38, 0];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_LANDSCAPE = [193, 193, 40, 44];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPAD_PORTRAIT = [435, 396, 21, 0];
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPAD_LANDSCAPE = [347, 308, 21, 0];

/**
 * Those are maximum height values of the address bar in case when the page was scrolled down.
 * @type {{iPhone: number, iPhoneX: number}}
 * */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.ADDRESS_BAR_HEIGHTS = {iPhone: 45, iPhoneX: 70};
/**
 * It is height value of the home button of iPhoneX or higher.
 * @type {number}
 * */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.IPHONE_X_HOME_BTN_HEIGHT = 15;

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable={};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone3GS"] = {
	name: "iPhone3GS",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone1, 3G"] = {
	name: "iPhone1, 3G",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone 1, 3G or 3GS"] = {
	name: "iPhone 1, 3G or 3GS",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone4"] = {
	name: "iPhone4",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone4s"] = {
	name: "iPhone4s",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE4_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone5"] = {
	name: "iPhone5",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE5_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE5_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone5s"] = {
	name: "iPhone5s",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE5_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE5_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone6"] = {
	name: "iPhone6",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone6s"] = {
	name: "iPhone6s",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone6Plus"] = {
	name: "iPhone6Plus",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone6sPlus"] = {
	name: "iPhone6sPlus",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone7"] = {
	name: "iPhone7",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone7Plus"] = {
	name: "iPhone7Plus",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone8"] = {
	name: "iPhone8",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone8Plus"] = {
	name: "iPhone8Plus",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6PLUS_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhoneX"] = {
	name: "iPhoneX",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEX_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEX_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhoneXSMax"] = {
	name: "iPhoneXSMax",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhoneXS_XSMaxZoomed"] = {
	name: "iPhoneXS_XSMaxZoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEX_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEX_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhoneXR"] = {
	name: "iPhoneXR",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhoneXRZoomed"] = {
	name: "iPhoneXRZoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEX_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEX_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone6Zoomed"] = {
	name: "iPhone6Zoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone6sZoomed"] = {
	name: "iPhone6sZoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone6PlusZoomed"] = {
	name: "iPhone6PlusZoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone6sPlusZoomed"] = {
	name: "iPhone6sPlusZoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone7Zoomed"] = {
	name: "iPhone7Zoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone7PlusZoomed"] = {
	name: "iPhone7PlusZoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone8Zoomed"] = {
	name: "iPhone8Zoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone8PlusZoomed"] = {
	name: "iPhone8PlusZoomed",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONE6_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone12"] = {
	name: "iPhone12",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_LANDSCAPE
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPhone12ProMax"] = {
	name: "iPhone12ProMax",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPHONEXR_LANDSCAPE
};

/* iPad and iPad mini */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable["iPad"] = {
	name: "iPad",
	portrait: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPAD_PORTRAIT,
	landscape: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTableValues.IPAD_LANDSCAPE
};
//endregion


com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.INDX_PREDICTIVE = 0;							/* Height of keyboard with predictive text */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.INDX_NONPREDICTIVE = 1;						/* Height of keyboard without predictive text */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.INDX_LANDSCAPE_FUDGEFACTOR = 2;				/* Fudge factor for landscape */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.INDX_LANDSCAPE_CHROMED_FUDGEFACTOR = 3;		/* Fudge factor for chromed landscape */


com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_INITIAL = 0;
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS = 1;
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLL = 2;
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLLTOBOTTOM = 3;
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLL_ABSOLUTE = 4;
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_COMPLETED = 5;
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_INITIAL_COMPLETED = 6;

/** @private @type {number} */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.keyboardHeightArray = [null, null];

/** @private @type {number} */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.iOS8ViewableHeight = 0;

/**
 * iOS gap height fix is only used if the skin sets the `iosGapFix` property to `true`.
 * The intention is to make the chatfooter taller in case predictive text is off by increasing chatfooter's height,
 * therefore if predictive text is off, the user will see a longer chatfooter instead of the client's website.
 * See RTDEV-21557
 * @private @type {number}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.iOSGapFixHeight = 0;
/** @private @type {number} */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.chatFooterDefaultHeight = 0;
/** @private @type {?number} */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.chatWindowDefaultBottom = null;

/** @private @type {HTMLElement} */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.iOS8FocusElement = null;
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.focusTimerId = -1;

/**
 * handleUnwantedScrollsDebounceCB
 *
 * RTDEV-25960
 *
 * This is debounce call-back function to handle UI issues caused by unwanted scrolls.
 * Some of the unwanted scrolls handled are:
 *  Scenario 1: On a pre-chat/post-chat survey (PCS), when you focus on text box, safari automatically scrolls
 *      it up to make sure the text box is in the middle. When this happens, our resized Chat or PCS window
 *      moves up a bit exposing the client page between the bottom of the window and the virtual keyboard
 *  Scenario 2: When you try to scroll a resized chat or PCS window, the address bar gets hidden and again  exposes
 *      the client page between the bottom of the window and the virtual keyboard. *
 *  Since the solution involves calculating the scroll offset and then scrolling the window, debouncing this
 *  scroll is very important else it can lead to mulple scroll events to be called.
 * @param {number} keyboardHeight - height of keyboard in pixels
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.handleUnwantedScrollsDebounceCB = com.inq.utils.Util.debounce(function () {
	var origVph = com.inq.utils.Capabilities.getOrigViewPortHeight();
	var pWin = window.parent;
	var currentVph = parseInt(pWin.innerHeight);
	var bVphDiff = (origVph != 0 && origVph < currentVph) ? true : false;
	var tcChatSkinPos = com.inq.ui.Container._getElementById("tcChat_Skin",pWin.document).getBoundingClientRect().top;
	//If the 'top' position of the chat skin is lesser than 5, then scroll it so that it becomes 0
	//TODO: even the positive difference should be scrolled, but on few iphones, 30 needs to be added to make up for the bookmark bar
	if (tcChatSkinPos < -5) {
		pWin.scrollTo(0, tcChatSkinPos);
	} else if (bVphDiff) {
		/*This is to handle the scenario 2 from the description above. When the address bar and bookmark bar is hidden,
		 the viewport height is greater than the original. If so, scroll the window by -1 and safari automatically makes
		 the address bar and the bookmark bar visible.*/
		pWin.scrollTo(0, -1);
	}
}, 100);


/**
 * setKeyboardHeight
 * @param {number} keyboardHeight - height of keyboard in pixels
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.setKeyboardHeight = function(keyboardHeight) {
	 this.keyboardHeightArray[(com.inq.utils.Capabilities.getOrientation()) ? 0 : 1] = keyboardHeight ;
};


/**
 * getKeyboardHeight
 * @return {number} keyboardHeight - height of keyboard in pixels
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.getKeyboardHeight = function() {
	return this.keyboardHeightArray[(com.inq.utils.Capabilities.getOrientation()) ? 0 : 1] ;
};


/**
 * FixIPhoneFocusScroll
 * Fix the positioning of an element after focus messes it up :)
 *
 * @private
 * @static
 * @return {boolean} true if correction is needed
 */
 com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.FixIPhoneFocusScroll = function() {
	return false;
 };


/**
 * blurFocusedElement - blur focused element
 *
 * @public
 * @override
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.blurFocusedElement = function() {
	try {
		this.focusScroll = null;
		if (this.iOS8FocusElement === null) return;
		/** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7} */
		var __this__ = this;
		com.inq.utils.Timer.delay(function() {
			__this__.iOS8FocusElement.blur();
		},100);
	} catch (err) {
		haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 371, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "blurFocusedElement"});
	}
};


/**
 * resizeToViewport
 * Resize the chat so that it fills the viewport.
 *
 * This is what we want to do:
 *	 1) disable the scroll monitor, it messes us up for our sizing of the viewport
 *	 2) If we have focus and on iphone or ipad, we want to
 *		2a) scroll to the bottom, this requires us to:
 *			* change the clients body style to allow us to scroll down, we change the minHeight and minWidth
 *			* to set listener for scroll the scroll down.
 *			* At completion of scroll down, get viewport and restore body minHeight and minWidth
 *			* Reenable scroll monitor
 *	3) No focus,
 *		get viewport size
 *		reenable scroll monitor
 *
 * We will get the size of the keyboard and use it for later, we do NOT have to keep going to the bottom of the page to calculate the screen size
 * We will keep a keyboard height for portrait and for landscape modes.
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function resizeToViewport():Void
 * @public
 * @static
 * @param {string}  from
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.resizeToViewport = function(from) {
	/** @type {com.inq.ui.Canvas} */
	var chatFooter = Application.application.getMxmlItem("chatFooter");
	/** @type {com.inq.ui.TextArea} */
	var chatWindow = Application.application.getMxmlItem("chatWindow");
    // If chat is minimized, I do not want to resize chat.
    if(this.bResizeToViewport || com.inq.flash.client.control.MinimizeManager.minimized)
        return;
	this.bResizeToViewport = true;
	/** @type {Window} */
	var clientWin = window.top;

    // if its a device with a virtual keyboard and we are responding to focus event ( on a text input ).. we are resizing to make room for keybd
	if (this.hasFocus && (com.inq.utils.Capabilities.isPhone() || com.inq.utils.Capabilities.isIpad())) {
		/* If we are here, then we know the keyboard height and we can calculate the viewport size */
		this.resizeToViewportFocused();
		this.bResizeToViewport = false;
	} else {
		this.zoomViewport(clientWin);
		com.inq.flash.client.chatskins.ScrollMonitor.bindAll();
		try {
			this.viewPort = com.inq.utils.Capabilities.getViewport();

			if (this.chatFooterDefaultHeight != 0) {
				chatFooter.setHeight(com.inq.ui.Container.encodeSize(this.chatFooterDefaultHeight));
			}
			if (this.chatWindowDefaultBottom !== null && !isNaN(this.chatWindowDefaultBottom)) {
				chatWindow.setStyle("bottom", com.inq.ui.Container.encodeSize(this.chatWindowDefaultBottom));
			}

			Application.SetArea(this.viewPort);
			Application.Resize();

			this.bResizeToViewport = false;
		} catch (err) {
			haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 111, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7", methodName : "resizeToViewport"});
			this.bResizeToViewport = false;
		}
	}
};



/** resizeToViewportFocused - Resize the chat area when we have focus and the virtual keyboard is in view
 *
 * Form MOB-721
 * Please note: this can be called when we do not have a resized canvas, so we must:
 *  1) get the current area of the Application for the width and height
 *  2) Check the width and height of the viewport to see if it has changed
 *  3) If it has changed, and only if it has changed then
 *     a) set the new area via Application.SetArea
 *     b) resize
 *     c) scroll the transcript down.
 *
 * @private
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.resizeToViewportFocused = function() {
	/** @type {Window} */
	var clientWin = window.parent;
	/** @type {com.inq.utils.Area} */
	var oldSize = Application.GetArea();
	/** @type {boolean} */
	var gapHeightFix = com.inq.utils.Util.getConfig("iosGapFix", false);
	/** @type {com.inq.ui.Canvas} */
	var chatFooter;
	/** @type {com.inq.ui.TextArea} */
	var chatWindow;

	this.viewPort = com.inq.utils.Capabilities.getViewport();
	this.viewPort.h = this.calculateViewableArea();

	haxe.Log.trace("viewport height: " + this.viewPort.h, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 1239, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7", methodName : "resizeToViewportFocused"});

	if (gapHeightFix && this.iOSGapFixHeight) {
		chatFooter = Application.application.getMxmlItem("chatFooter");
		chatWindow = Application.application.getMxmlItem("chatWindow");
		if (this.chatFooterDefaultHeight == 0) { // this will be 0 when you navigate to a new page and then you do a resume chat.
			this.chatFooterDefaultHeight = chatFooter.getHeight();
		}
		if (this.chatWindowDefaultBottom === null) {
			this.chatWindowDefaultBottom = parseInt(chatWindow.getStyle("bottom"));
		}
		chatFooter.setHeight(com.inq.ui.Container.encodeSize(this.chatFooterDefaultHeight + this.iOSGapFixHeight));
		if (!isNaN(this.chatWindowDefaultBottom)) {
			chatWindow.setStyle("bottom", com.inq.ui.Container.encodeSize(this.chatWindowDefaultBottom + this.iOSGapFixHeight));
		}
	}

	Application.SetArea(this.viewPort);
	Application.Resize();

	this.zoomViewport(clientWin);

	/* Check to see if the viewport has changed, if it hasn't we do not want to set the area, resize and scroll the transcript down */
	if (this.viewPort.h != oldSize.h || this.viewPort.w != oldSize.w) {
		com.inq.utils.Timer.delay(function() {
			com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
		}, 1);

	}
};

/**
 * Return viewable area, excluding virtual on-screen keyboard, address bars
 *
 * @private
 * @returns {number} the viewable area with virtual keyboard showing
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.calculateViewableArea = function() {
	this.calculateIOSGapFixHeight();

	if (this._isFirstFocusOnElement()) {
		this._removeFirstFocusAttribute();
		return this._getFullScreenHeight();
	}

	if (this._inputTypeHasNoKeyboard() || this._isIPhoneWebViewSmallViewport_Safari7()) {
		return this._getFullScreenHeight();
	}

	return this._calculateViewportHeight();
};

/**
 * Sets this instance's `iOSGapFixHeight` member to equal the keyboard predictive text height. See
 * ChatTextFocusMonitorImplIphoneSafari7.iOSGapFixHeight for further explanation about this hack.
 *
 * `iOSGapFixHeight` is then read by resizeToViewportFocused when resizing the chat.
 *
 * @see {ChatTextFocusMonitorImplIphoneSafari7#iOSGapFixHeight}
 * @see {ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 * @see {ChatTextFocusMonitorImplIphoneSafari7#resizeToViewportFocused}
 * @private
 * @return {undefined}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.calculateIOSGapFixHeight = function () {
	var gapHeightFix = com.inq.utils.Util.getConfig("iosGapFix", false);

	if (gapHeightFix) {
		var keyboardValues = this.getKeyboardValues();

		var predictiveTextHeight = keyboardValues.withPredictive - keyboardValues.withoutPredictive;
		this.iOSGapFixHeight = predictiveTextHeight;
	}
};

/**
 * Edge case scenario when calculating viewable area
 *
 * RTDEV-20045
 * Return clientWin.innerHeight if it is too small.  This needs to be done to fix this problem for
 * Verizon Fios app. For this app, the clientWin.innerHeight value only a little > kn
 *
 * @return {boolean}
 * @private
 * @see {ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._isIPhoneWebViewSmallViewport_Safari7 = function () {
	var isIOSWebView = com.inq.utils.Capabilities.isIOSWebView();
	var isPortrait = com.inq.utils.Capabilities.getOrientation();
	var smallViewPort = this._calculateViewportHeight() < Application.minHeight;

	return isPortrait && isIOSWebView && smallViewPort;
};

/**
 * Calculate viewport height based on: hard-coded model-specific keyboard heights, portrait/landscape mode adjustments
 *
 * @return {number}
 * @private
 * @see {ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._calculateViewportHeight = function () {
	var keyboardHeight = this._getPredictiveTextAdjustedKeyboardHeight() + this._getLandscapeKeyboardHeightAdjustment();
	var viewPortHeight = this._getFullScreenHeight() - keyboardHeight - this._getBrowserPanelsHeightFix();

	return viewPortHeight;
};

/**
 * We recalculate viewable height in the case when the page was
 * scrolled down and browser system panels were hidden.
 * The main idea is to calculate the original size of the system keyboard
 * by adding the missing height of the keyboard which doesn't calculate
 * because of the wrong viewport height when the system panels of the Safari browser are displayed.
 *
 * @returns {number}
 * @private
 * @see {ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._getBrowserPanelsHeightFix = function () {
	var isIPhoneXOrHigher = com.inq.utils.Capabilities.isIPhoneXOrNewer();
	var availableHeight = com.inq.utils.Capabilities.getAvailHeight();

	var systemComponentsHeight = availableHeight - this._getFullScreenHeight();
	var addressBarHeight = isIPhoneXOrHigher ?
		com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.ADDRESS_BAR_HEIGHTS.iPhoneX
		: com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.ADDRESS_BAR_HEIGHTS.iPhone;
	var iPhoneXHomeBtnHeight = isIPhoneXOrHigher ? com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.IPHONE_X_HOME_BTN_HEIGHT : 0;
	var browserPanelsFixHeight = (systemComponentsHeight - addressBarHeight) <= 0 ? (systemComponentsHeight + iPhoneXHomeBtnHeight) : 0;

	return browserPanelsFixHeight;
};

/**
 * Get keyboard height depending on whether predictive text is on/off
 *
 * @return {number}
 * @private
 * @see {ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._getPredictiveTextAdjustedKeyboardHeight = function () {
	var type = this.iOS8FocusElement ? this.iOS8FocusElement.type.toString().toUpperCase() : null;
	var gapHeightFix = com.inq.utils.Util.getConfig("iosGapFix", false);
	var keyboardValues = this.getKeyboardValues();

	// Get the type of input, if it is "Password" then we know that we do not have predictive text
	if (type === "PASSWORD" || com.inq.utils.Capabilities.isSafariVersionPrior8() || gapHeightFix) {
		return keyboardValues.withoutPredictive;
	} else {
		return keyboardValues.withPredictive;
	}
};

/**
 * Return the height difference between landscape and portrait mode for the keyboard. Returns 0 for portrait mode.
 *
 * @returns {number}
 * @private
 * @see {ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._getLandscapeKeyboardHeightAdjustment = function () {
	var isLandscape = com.inq.utils.Capabilities.getOrientation() === false;
	var keyboardValues = this.getKeyboardValues();

	var landscapeFix = 0;

	if (isLandscape) {
		if (com.inq.utils.Capabilities.isChromed()) {
			landscapeFix = keyboardValues.fudgeFactorChromed;
		} else {
			landscapeFix = keyboardValues.fudgeFactorLandscape;
		}
	}

	return landscapeFix;
};

/**
 * Return hard-coded keyboard heights based on iPhone model and orientation.
 *
 * @see {ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 * @private
 * @returns {{withPredictive: number, withoutPredictive: number, fudgeFactorLandscape: number, fudgeFactorChromed: number}}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.getKeyboardValues = function () {
	var isPortrait = com.inq.utils.Capabilities.getOrientation();
	var iPhoneModel = com.inq.utils.Capabilities.getiPhoneModel();
	var orientation = isPortrait ? "portrait" : "landscape";
	var keyboardTable = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.KeyboardTable;

	var keyboardValuesArray = keyboardTable[iPhoneModel][orientation];

	var keyboardValues = {
		withPredictive: keyboardValuesArray[0],
		withoutPredictive: keyboardValuesArray[1],
		fudgeFactorLandscape: keyboardValuesArray[2],
		fudgeFactorChromed: keyboardValuesArray[3]
	};

	return keyboardValues;
};

/**
 * Returns whether the text input element has been focused on for the first time.
 * Used as a work around when using calculateViewableArea for some edge case.
 *
 * @returns {boolean}
 * @private
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._isFirstFocusOnElement = function () {
	if (this.iOS8FocusElement) {
		return this.iOS8FocusElement.hasAttribute("data-first-focus");
	}

	return false;
};

/**
 * Remove 'data-first-focus' attribute from the text input element
 * Used after the element has been focused at least once.
 *
 * @private
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7#_isFirstFocusOnElement}
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._removeFirstFocusAttribute = function () {
	this.iOS8FocusElement.removeAttribute("data-first-focus");
};

/**
 * Return top window's `innerHeight` property
 *
 * @returns {number}
 * @private
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._getFullScreenHeight = function () {
	var clientWin = com.inq.utils.Util.getTopWindow();
	return clientWin.innerHeight;
};

/**
 * Returns whether the element type has a virtual onscreen keyboard
 *
 * RTDEV-19553: The keyboard height should not be considered for select/combo boxes
 * RTDEV-20306 Similar stub for "RADIO"
 *
 * @returns {boolean}
 * @private
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype._inputTypeHasNoKeyboard = function () {
	var elementType;

	if (this.iOS8FocusElement) {
		elementType = this.iOS8FocusElement.type.toString().toUpperCase();
	}

	return elementType === "SELECT-ONE" ||  elementType === "RADIO";
};

/**
 * onScrollCallback - callback for the scroll monitor for specific action per implementation
 *
 * @see com.inq.flash.client.chatskins.ScrollMonitor.whenPhoneScroll
 */

/** onScrollCallback - handle scrolling event for iOS7 and maybe iOS8
 *	When the scroll manager sees the scroll event, it calls us
 *  We know the following
 *		On the iPhone (all versions) when we get a FOCUS event, it is followed by a scroll event, guaranteed.
 *		This happens so the virtual keyboard manager can assure that the input field is scrolled into view.
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.onScrollCallback=function(){
	try {

		/** @type {Window} */
		var clientWin = window.parent;
		var clientDoc = clientWin.document;
		/** @type {number} */
		var bottomScroll = Math.max(	clientDoc.body.scrollHeight,
			clientDoc.body.offsetHeight,
			clientDoc.documentElement.clientHeight,
			clientDoc.documentElement.scrollHeight,
			clientDoc.documentElement.offsetHeight );
		haxe.Log.trace("State: " + this.scrollState, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 380, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onScrollCallback"});

		if (com.inq.flash.client.control.MinimizeManager.minimized)
			return;

		/** @type {Boolean} */
		var stageVisible = com.inq.ui.Stage.getInstance().getVisible();
		if (!stageVisible)
			return;

		switch(this.scrollState) {
			case undefined:
				haxe.Log.trace("State is undefined!!!: " + this.scrollState, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 391, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onScrollCallback"});
				break;
			case com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS:

				/** @type {number} */
				var height = this.getKeyboardHeight();
				if (!height) {		/* If we have the keyboard height, then use it, otherwise calculate it and keep it */
					/* Now scroll to the bottom */
					this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLLTOBOTTOM;
					haxe.Log.trace("State: " + this.scrollState, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 402, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onScrollCallback"});
					this.viewPort = com.inq.utils.Capabilities.getViewport();
					com.inq.utils.Timer.delay(function() {
						clientWin.scrollTo(0, clientWin.scrollY==1?2:1);		/* now scroll to the near top ,if it is already on top then change the scrollY by another 1*/
					}, 1);
				} else {
					haxe.Log.trace("Keyboard height: " + height, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 142, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7", methodName : "uponScrolliOS7"});
					this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLL_ABSOLUTE;
					haxe.Log.trace("State: " + this.scrollState, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 408, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onScrollCallback"});
					com.inq.utils.Timer.delay(function() {
						clientWin.scrollTo(0, bottomScroll);		/* now scroll all the way down */
					}, 1);
				}
				break;

			case com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLL_ABSOLUTE:
				this.saveScrollPosition();  // This sets curScroll, needed by onFocusRelatedTarget.
				this.focusScroll = this.curScroll;
				var that = this;
				/**
				 * wait for all scroll event to finish before rendering.This way we can avoid flickering effect
				 */
				clearTimeout(this.focusTimerId);
				this.focusTimerId = setTimeout(function () {
					if (!that.hasFocus) {
						if (clientDoc.activeElement.tagName.toLowerCase() === "input") {
							that.setHasFocus(true);
							that.bindOrientationListener();
						} else {
							return;
						}
					}
					/*
					  RTDEV-27021: calculate the viewable height just before the resize.
					 If the client page is too small and is not scrollable, then window.innerHeight gives incorrect values when scrolling is forced.
					 Hence calculateViewableArea should be placed right before resizeToViewportFocused, as the bottom and top scroll is already done at this point
					 */
					that.iOS8ViewableHeight = that.calculateViewableArea();
					that.resizeToViewportFocused();
					clientWin.scrollTo(0,0);
				},250);
				break;

			case com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLLTOBOTTOM:
				/* We have scrolled to the bottom, we need to scroll to the top now */
				this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLL_ABSOLUTE;
				/* Scroll back to the top to continue calculation for hte correct height */
				com.inq.utils.Timer.delay(function() {
					clientWin.scrollTo(0, clientWin.scrollY === 0 ? -1 : 0);
				}, 1);
				break;
			case com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_INITIAL:

				//"0" is initial value. Once set, value should not been overridden.
				if (this.chatFooterDefaultHeight == 0) {
					this.chatFooterDefaultHeight = Application.application.getMxmlItem("chatFooter").getHeight();
				}
				if (this.chatWindowDefaultBottom === null) {
					this.chatWindowDefaultBottom = parseInt(Application.application.getMxmlItem("chatWindow").getStyle("bottom"));
				}
				var clientBody = clientDoc.body;
				/* Resize if the size has changed */
				if (this.viewPort !== null &&
					!this.hasFocus &&
				    this.viewPort.h !== clientWin.innerHeight) {
					this.viewPort.h = clientWin.innerHeight;
					this.resizeToViewport("Fix Height");
				} else {
					/**
					 * RTDEV-16316
					 * This is a follow up ticket for RTDEV-16228 to fix CATO problem.  The problem is on initial load or
					 * screen refresh, the chat skin does not lineup properly. This problem only happens for
					 * iphone and only when Accessibility VoiceOver is on. I noticed when the problem occurs, the clientRect top
					 * and the parent document body margin top are different.  To fix the problem, we need to call
					 * resizeToViewport one more time.
					 */
					if ((Application.parentDocumentBodyMarginTop !== 0) && (clientBody.getBoundingClientRect().top !== Application.parentDocumentBodyMarginTop)) {
						this.resizeToViewport("Fix Height");
					}
				}
				/*
				 * Add "height:auto" to the client page <HTML>.
				 * Means, the element will have flexible height i.e. its height
				 * will depend upon the height of children elements of it.
				 * Used to set height to the same size as chat window has.
				 */
				com.inq.flash.client.chatskins.ScrollMonitor.addAutoHeight();
				/*
				 * RTDEV-18422
				 * This is a work around solution for this issue. When the user executes the steps described in the
				 * ticket on the iPhone, the window.parent.innerHeight becomes taller then it is supposed to be.
				 * On the iPhone that I tested, the innerHeight was normally 628. When the steps are executed, the
				 * innerHeight became 672 and therefore, the textInput box is put below the screen.  If I manually set
				 * the innerHeight back to 628, the textInput box will appear.  The problem is I do not know what is
				 * the expected value for innerHeight.  By try and error, I discovered the following will also fix
				 * the problem.
				 */
				window.top.scrollTo(0, 1);
				/**
				 * I need to change the state after the first initial because due to the above code from tam causing infinite scroll event . Every time
				 */
				this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_INITIAL_COMPLETED;
				break;
            case com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_COMPLETED:
                com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.handleUnwantedScrollsDebounceCB();
                break;
            default:

		}
	} catch (err) {
		haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber : 154, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7", methodName : "uponScrolliOS8"});
	}
};

/**
 * onBlur - Restore the original scroll position & chat dimensions.
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * static public function onBlur(?me:MouseEvent):Bool
 * @public
 * @param {FocusEvent}  ev
 * @param {HTMLElement}  element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.onBlurImpl = function(ev, element) {
	this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_INITIAL;
	/* super.onBlurImpl */
	this.focusElement = null;
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.__super__.prototype.onBlurImpl.call(this, ev, element);
};


/**
 * onFocusImpl - Restore the original scroll position & chat dimensions.
 *
 * This is currently (as of MOB-599) a bucket to hold everything that
 * needs to be moved into subclasses.
 *
 * @public
 * @param {FocusEvent} ev
 * @param {HTMLElement} element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.onFocusImpl = function(ev, element) {
	/* Set state to as has focus waiting for scroll; */
	this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS;
	this.iOS8FocusElement = element;

	this.invokeScrollToResize();

	/* super.onFocusImpl */
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.__super__.prototype.onFocusImpl.call(this, ev, element);
};

/**
 * invokeScrollToResize - is used to scroll client window if scroll event doesn't fire
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.invokeScrollToResize = function() {
	var that = this;

	com.inq.utils.Timer.delay(function() {
		/** @type {Window} */
		var clientWin = window.parent;
		/**
		 * in case if scroll event did not fire in 100ms then force the scroll
		 * for com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLL_ABSOLUTE
		 */
		if (that.scrollState !== com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLL_ABSOLUTE) {
			clientWin.scrollBy(0, 1);
		}
	}, 100) ;
};

/**
 * expandChat - is used to resize the chat interface and display the chat in full screen mode.
 * The current implementation is supported for iPhone only.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.expandChat = function() {
	this.setHasFocus(false);
	this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_INITIAL;

	this.onBlurHandlerScheduleId =
		com.inq.utils.Capabilities.setDomSafeTimeout(
			this.onBlurHandlerPhoneIphone,
			1);

	return true;
};

/**
 * shrinkChat - is used to resize the chat interface when software keyboard is displayed.
 * The current implementation is supported for iPhone only.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.shrinkChat = function() {
	this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS;

	this.setHasFocus(true);
	this.savePosition();
	this.invokeScrollToResize();
	this.bindOrientationListener();
	this.fixChatPosition();

	return true;
};

/**
 * This function solves the issue of page scroll when input element gets focus
 * @deprecated
 * @param {Event} ev
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.onFocusRelatedTargetImpl = function(ev){
	this.setHasFocus(true);
	var __this__ = this;
	com.inq.utils.Timer.delay(function() {
		window.top.scrollTo(__this__.focusScroll.X, __this__.focusScroll.Y);
	},100);
	ev.preventDefault();
}


/**
 * onOrientationChange
 * Respond to orientation changes.
 *
 * static public function onOrientationChange(ev:Event):Bool
 * @public
 * @param {js.Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.onOrientationChange = function(ev) {
	this.blurFocusedElement();
	/** @type {Window} */
	var clientWin = window.parent;
	clientWin.scrollTo(0,0);
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.__super__.prototype.onOrientationChange.call(this, ev);
};

/**
 * onTouchStart - Capture window scroll position at start of touch event
 *
 * We added functionallity to the superclass
 *  We want to intercept the touch event to fire off buttons.
 * Why do we want to do that??????? Huh!!!
 *
 * Reason: Safari 8 misbehaves when we click a button, the focus is lost and the keyboard detracts.
 *  We simulate the button press on the TouchStart event and avoid the loss of focus (blur).
 *  We ONLY want to do this when we have focus and the keyboard is up.
 *
 * @private
 * @see onTouchEnd
 * @see onFocus
 * @param {Event} ev
 * @param {HTMLElement}  element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.onTouchStart = function(ev, element) {
	/* We want to see if we are touching a button
	 * So we get the element we will check the container attribute (we added this attribute in container.js)
	 * If we are focused && ios8 && container is a button then we want to fire the click event and swallow the touch event
	 *
	 * We want to do this so we do not loose focus and drop the virtual keyboard
	 */
	haxe.Log.trace("onTouchStart: ", { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber :465, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onTouchStart"});
	/**
	 * @see http://jira.touchcommerce.com/browse/RTDEV-11087
	 * @description window.popup will work only when invoked from a click event on IOS.This code will prevent the onclick event from firing so i added a condition
	 */
	/** @type {HTMLElement} */
	 var el = ev.target;
	 if (this.hasFocus && el && (el.id.indexOf("btnCloseChat") === -1 || !com.inq.utils.Capabilities.isIphone())) {
		haxe.Log.trace("target element: " + element.id, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber :465, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onTouchStart"});

		try {
			/** @type {com.inq.ui.Container} */
			var possibleButton = el.container;
			if (possibleButton) {
				if (js.Boot.__instanceof(possibleButton, com.inq.ui.Button)) {
					ev.preventDefault();
					/*softClick is firing a mouse click event causing keyboard hide in webview */
					!com.inq.utils.Capabilities.isIOSWebView() && possibleButton.softClick();
					haxe.Log.trace("softClick: ", { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber :473, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onTouchStart"});
				} else {
				/* Set the soonToHaveFocus to the container object */
					haxe.Log.trace("Not a button: ", { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber :479, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onTouchStart"});
					this.soonToHaveFocus = possibleButton;
					this.soonToHaveFocusTime = new Date().getTime() + 500 ;
				}
			}
			else {
				haxe.Log.trace("Not a Button: ", { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber :485, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onTouchStart"});

				/* Set the soonToHaveFocus to null */
				this.soonToHaveFocus = null;
				this.soonToHaveFocusTime = new Date().getTime() + 500 ;
                /*RTDEV-22017: When the virtual keyboard gets hidden for listboxes, the viewport needs to resized*/
				if(el.parentNode && el.parentNode.getAttribute("role")=="listbox") {
                    var tcChatSkin = com.inq.ui.Container._getElementById("tcChat_Skin",parent.document);
                    var chatPosBfr = tcChatSkin.getBoundingClientRect().top;
					window.setTimeout(function() {//timeout is necessary because the virtual keyboard should first be hidden
                        var chatPosAfr = tcChatSkin.getBoundingClientRect().top;
                        //By comparing the before and after position thru getBoundingClientRect(), we can determine if the virtual keyboards gets hidden
                        // Resize is required only if the keyboard is hidden.
                        if(chatPosBfr != chatPosAfr) {
                            com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.resizeToViewport();
                        }
					}, 500);
				} else if (el.nodeName == "SELECT") {
					/*RTDEV-25941: when the foucs moves to a select box, resize to viewport if not already..*/
					window.setTimeout(function () {
						var vPort = com.inq.utils.Capabilities.getViewport();
						var oldArea = Application.GetArea();
						if (oldArea.h < vPort.h || oldArea.w < vPort.w) {
							com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.prototype.resizeToViewport();
						}
					}, 500);
				}
			}
		} catch (err) {
			haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplIphoneSafari7.js", lineNumber :485, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitor", methodName : "onTouchStart"});
		}
	 }

	/**
	 * This is to make sure that once the keyboard is up and user starts touching on the screen. i am preventing screen from re-rendering on every scroll event.
	 */
	if(this.scrollState == com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_SCROLL_ABSOLUTE) {
		this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_FOCUS_COMPLETED;
	}

	/* super.onTouchStart */
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.__super__.prototype.onTouchStart.call(this,ev);
};

